<template>
    <lv-base-column
            ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-radio-item
                    :row="row"
                    :disabled="disabled"
                    :edit-row="editRow"
                    :row-index="rowIndex"
                    :col="col"
                    :col-index="colIndex"
                    :fixed-row="fixedRow"
                    v-bind="columnItemBinding"

                    :true-label="trueLabel"
                    :false-label="falseLabel"
                    :scope-slot-func="$scopedSlots.default"
                    @change="setDefault"
                    @click="lv_clickItem"/>
        </template>
    </lv-base-column>
</template>

<script>
    import {ColumnMixin} from '../mixins';
    import LvBaseColumn from '../../table/lv-base-column';
    import LinkTableColumnRadioItem from './link-table-column-radio-item';

    export default {
        mixins: [ColumnMixin],
        components: {LvBaseColumn, LinkTableColumnRadioItem},
        name: 'link-table-column-radio',
        props: {
			order: {default: 9998},
            align: {default: 'center'},
            width: {default: '20px'},
            sort: {default: false},
            search: {default: false},
            fastRender: {default: false},
            columnFilter: {default: false},                 //默认禁用列筛选

            trueLabel: {type: String, default: () => 'Y'},
            falseLabel: {type: String, default: () => 'N'},
            radioType: String,
            disabled: {type: Boolean, default: () => false}

        },
        methods: {
        	/**
        	 * @method：getBaseTable
        	 * @createdBy：黄健
        	 * @date：2020-02-04
        	 * @params：
        	 * @description：获取BaseTable实例
        	 */
			getBaseTable(){
				if(!this._baseTable){
					this._baseTable = this.$getParentComponent('lv-base-table');
				}
				return this._baseTable;
			},
        	/**
        	 * @method：getChecked
        	 * @createdBy：黄健
        	 * @date：2020-02-04
        	 * @params：
        	 * @description：获取选中行
        	 */
			getChecked(){
				const baseTable = this.getBaseTable();
				const list = baseTable.data || [];
				return list.find((t)=>t[this.field] === this.trueLabel);
			},
            /**
             * @method：setDefault
             * @createdBy:HuangJian
             * @date:2019/2/26
             * @params：
             * @description：选中值变化时触发
             */
            setDefault(row, newVal) {
				const baseTable = this.getBaseTable();
				const list = baseTable.data || [];
                list.forEach((item) => {
                    const val = row.id !== item.id ? this.falseLabel : newVal;
                    this.$set(item, this.field, val);
                });
                var defaultRowId = row.id;
                if (newVal === this.falseLabel) {
                    defaultRowId = ' ';
                }
                this.$emit('set-default', defaultRowId, row);
            }
        }
	};
</script>

<style scoped>

</style>
